module.exports = __webpack_public_path__ + "img/img_10.a9c0c69e.svg";